import { SetActivitySummaryFiltersAction } from './typings'

export function setActivitySummaryFiltersActionCreator(
  payload: SetActivitySummaryFiltersAction['payload'],
): SetActivitySummaryFiltersAction {
  return {
    type: 'activitySummary/setFilters',
    payload,
  }
}
